<template>
  <v-app class="legacy-workspace">
    <core-drawer @toggleDrawer="toggleDrawer" :drawer="drawer"></core-drawer>
    <core-toolbar @openDrawer="openDrawer" :drawer="drawer"></core-toolbar>
    <v-main>
      <div v-if="containerView" class="container-fluid pb-3">
        <router-view></router-view>
      </div>
      <router-view v-else></router-view>
    </v-main>
    <core-footer></core-footer>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import CoreDrawer from './core/Drawer'
import CoreFooter from './core/FooterDense'
import CoreToolbar from './core/Toolbar'
export default {
  name: 'DashVuetify',
  components: {
    CoreFooter,
    CoreDrawer,
    CoreToolbar
  },
  data: function() {
    return {
      drawer: false
    }
  },
  watch: {
    '$route' (to, from) {
      // close drawer to route changes...
      this.drawer = false
    }
  },
  computed: {
    ...mapState(['userInfo', 'user']),
    containerView() {
      let excludeNames = [
        'Payment Consolidation',
        'All Influencers',
        'IMS Influencers',
        'AOK Report',
        'Archived Payment Consolidation',
        'All Campaigns Report',
        'Upcoming Review Meetings',
        'Campaign Timeline',
        'Client Feedbacks',
        'Archived Client Feedbacks',
        'Payout Submission',
        'Campaign Report Internal',
        'Campaign COGS',
        'Creator Stats & Rating',
        'Posts',
        'Campaign Report',
        'Campaign Timeline Summary',
        'COGS Estimation',
        'Profit Summary',
        'Masterlist',
        'Invoices & Brief Confirmation',
        'Creators Search',
        'Stats Analysis',
        'Clients',
        'am-dashboard',
        'co-dashboard',
        'Keyword Search',
        'Ratecard Forms',
        'Creator Concept',
        'Content Search'
      ]
      if (excludeNames.includes(this.$route.name)) {
        return false
      }
      return true
    }
  },
  methods: {
    openDrawer() {
      if (this.drawer) this.drawer = false
      this.toggleDrawer()
    },
    toggleDrawer() {
      this.drawer = !this.drawer
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// DashVuetify.vue?6d8ef620